import { useQuery } from '@apollo/client';

import {
  GetUserQuery,
  GetUserQueryVariables,
} from '@notino/shared/definitions/types';

import { useAddToCartButtonContext } from '@sharedComponents/AddToCartButton/context';
import getUserQuery from '@sharedComponents/AddToCartButton/queries/user.graphql';

export const useUserProductsInfo = (productId: string | number) => {
  const {
    state: { withLegacyAddToCart },
  } = useAddToCartButtonContext();

  const { data } = useQuery<GetUserQuery, GetUserQueryVariables>(getUserQuery, {
    variables: {
      productIds: [productId.toString()],
    },
    skip: !withLegacyAddToCart,
    ssr: true,
  });

  return data?.userProductsInfo;
};
